<template>
    <div class="contents">
        <div class="flex mr-4" style="flex: 0">
            <v-badge
                v-if="item.participants.length > 1"
                :content="item.participants.length"
                overlap
                bottom
                color="dark"
                offset-y="20"
            >
                <v-avatar
                    :class="{
                        'unread-avatar':
                            !item.last_read ||
                            item.last_read < item.latest_message.created_at,
                    }"
                >
                    <v-img
                        :src="item.participants[0].profile_photo_url"
                    /> </v-avatar
            ></v-badge>
            <v-avatar
                v-else
                :class="{
                    'unread-avatar':
                        !item.last_read ||
                        item.last_read < item.latest_message.created_at,
                }"
            >
                <v-img
                    v-if="item.participants[0].profile_photo_url"
                    :src="item.participants[0].profile_photo_url"
                />
                <v-icon v-else size="48" color="dark">account_circle</v-icon>
            </v-avatar>
        </div>
        <v-list-item-content
            :class="{
                'font-weight-bold': item.unread,
            }"
        >
            <v-list-item-title class="ws-wrap soli-grey items-center"
                >{{
                    item.participants.length > 1
                        ? item.firstNameList
                        : item.fullNameList
                }}
            </v-list-item-title>

            <v-list-item-subtitle class="ws-wrap min-three-line">{{
                item.latest_message.content
            }}</v-list-item-subtitle>
            <div class="flex gap-2 items-center">
                <small
                    :class="{
                        'max-w-24 text-ellipsis whitespace-nowrap text-ellipsis overflow-hidden':
                            item.hasDraft,
                    }"
                    class="accent--text"
                    >{{ moment(item.updated_at).fromNow() }}</small
                >
                <v-chip
                    v-if="item.hasDraft"
                    color="accent"
                    x-small
                    :class="{
                        'gradient-ai white--text': item.auto_drafted_at,
                    }"
                    >{{
                        item.auto_drafted_at ? "Auto-drafted" : "Draft"
                    }}</v-chip
                >
            </div>
        </v-list-item-content>
    </div>
</template>

<script>
import { values } from "lodash";
import TipTapReader from "../Editor/TipTapReader.vue";

export default {
    components: {
        TipTapReader,
    },
    props: {
        item: {
            type: Object,
            default: () => {},
        },
        selected: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style scoped>
.min-three-line {
    min-height: 2em;
}
</style>
